module.exports = __webpack_public_path__ + "img/antes_despues_151.37bd568a.png";